import React from "react";
import { resolvePath } from "@utils/resolvePath";
import { connect } from "react-redux";
import { getWidgetSpecificIsVisible } from "@utils/index";
import { styled } from "@acko-tech/building-blocks.ui.common";
import { device } from "@utils/screens";
import { useEffect } from "react";
import Lottie from "lottie-react";
import Loader from "@public/lottieJson/loader.json";
import Success from "@public/lottieJson/success.json";
import Pending from "@public/lottieJson/pending.json";

const ImgTag = styled.img`
  @media ${device.mobileL} {
    ${(props: any) => props?.mStyles}
  }
`;

const mapStateToProps = function (state: any, ownProps: any) {
  return {
    is_visible: getWidgetSpecificIsVisible(
      state.configuration?.normalisedConfig,
      ownProps.id
    ),
  };
};

interface LottieConfig {
  width: number;
  height: number;
  jsonName: string;
  options: {
    loop: boolean;
    autoplay: boolean;
    rendererSettings: any;
  };
}

const Icon = ({
  overrideIsVisible,
  is_visible,
  path,
  styles,
  onClick = () => {},
  alt,
  src,
  mStyles = "",
  actions,
  type = "image",
  lottieConfig,
}: {
  overrideIsVisible?: boolean;
  is_visible: boolean;
  path?: string;
  styles?: any;
  onClick?: any;
  src?: string;
  alt?: string;
  mStyles?: string;
  actions: any;
  type?: "image" | "lottie";
  lottieConfig?: LottieConfig;
}) => {
  if (overrideIsVisible) is_visible = overrideIsVisible;

  useEffect(() => {
    if (is_visible) {
      actions?.on_load?.forEach((func: any) => {
        func.funCall?.(func.args);
      });
    }
  }, []);

  const onClickHandler = () => {
    onClick();
    actions?.on_click?.forEach((func: any) => {
      func.funCall?.(func.args);
    });
  };
  const getLottieJson = (jsonName: string) => {
    if (jsonName === "Loader") return Loader;
    if (jsonName === "Success") return Success;
    if (jsonName === "Pending") return Pending;
  };

  if (!is_visible) return <></>;

  if (type === "lottie" && lottieConfig)
    return (
      <div style={{ width: "100%", display: "flex", justifyContent: "center" }}>
        <Lottie
          animationData={getLottieJson(lottieConfig?.jsonName || "")}
          loop={lottieConfig.options.loop}
          autoplay={lottieConfig.options.autoplay}
          style={{ height: lottieConfig?.height, width: lottieConfig?.width }}
        />
      </div>
    );

  return (
    <>
      <ImgTag
        className="image"
        src={resolvePath(path || src || "")}
        style={styles}
        alt={alt}
        onClick={onClickHandler}
        mStyles={mStyles}
      />
    </>
  );
};

export default connect(mapStateToProps)(Icon);
